import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import {serviceFields} from '../../../../data/shared/fragments';
import Section from './section';
import ContentCard from '../../../../shared/library/cards/content';
import YouTubeIcon from '../../../../shared/library/icons/sources/youtube.svg';
import SlideShareIcon from '../../../../shared/library/icons/sources/slideshare.svg';
import MeetupsIcon from '../../../../shared/library/icons/sources/meetup.svg';
import EventBriteIcon from '../../../../shared/library/icons/sources/eventbrite.svg';
import glamorous from 'glamorous';
import {MobileContext} from '../../../../shared/enhancers/mobile-enhancer';
import {formatDate} from '../../../../shared/utils/format';
const IconWrapper = glamorous.div({
  '& svg': {
    width: 20,
    height: 20
  }
});

export const query = gql`
  query socialPosts($id: ID!, $first: Int, $after: String) {
    company(id: $id) {
      id
      socialPosts(first: $first, after: $after) {
        count
        edges {
          node {
            id
            private
            postType
            outboundUrl
            details
            publishedAt
            status
            services {
              ...serviceFields
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
  ${serviceFields}
`;

const TechTalks = ({companyId, count}) => {
  const isMobile = useContext(MobileContext);
  return (
    <Section
      title="Tech Talks"
      count={count}
      query={query}
      dataKey="socialPosts"
      variables={{id: companyId}}
      gridCols={isMobile ? 1 : 2}
    >
      {({edges}) =>
        edges
          ? edges.map(e => {
              let props = {};
              switch (e.node.postType) {
                case 'youtube':
                  props = {
                    header: e.node.details['thumbnail_url'],
                    overlay: <YouTubeIcon />,
                    tallHeader: true,
                    text: e.node.details['description'],
                    infoComponent: (
                      <IconWrapper>
                        <YouTubeIcon />
                      </IconWrapper>
                    )
                  };
                  break;
                case 'slideshare':
                  props = {
                    embedHeader: e.node.details['embed'],
                    text: e.node.details['description'],
                    infoComponent: (
                      <IconWrapper>
                        <SlideShareIcon />
                      </IconWrapper>
                    )
                  };
                  break;
                case 'meetup':
                  props = {
                    bigTitle: true,
                    text: formatDate('MMMM Do YYYY, [@]h:mm a', Date.parse(e.node.publishedAt)),
                    infoComponent: (
                      <IconWrapper>
                        <MeetupsIcon />
                      </IconWrapper>
                    )
                  };
                  break;
                case 'eventbrite':
                  props = {
                    bigTitle: true,
                    text: formatDate('MMMM Do YYYY, [@]h:mm a', Date.parse(e.node.publishedAt)),
                    infoComponent: (
                      <IconWrapper>
                        <EventBriteIcon />
                      </IconWrapper>
                    )
                  };
                  break;
                default:
              }
              const title = e.node.details && e.node.details['title'];
              return (
                <ContentCard
                  id={e.node.id}
                  key={e.node.id}
                  url={e.node.outboundUrl}
                  services={e.node.services}
                  title={title}
                  clickContentEvent="click_techTalkCard"
                  clickContentParams={{
                    title,
                    techtalk_url: e.node.outboundUrl
                  }}
                  {...props}
                />
              );
            })
          : null
      }
    </Section>
  );
};

TechTalks.propTypes = {
  companyId: PropTypes.any.isRequired,
  count: PropTypes.number.isRequired
};

export default TechTalks;
